var cibCodio = ["32 32", "<path d='M15.995 32l-13.855-8.005v-16l13.86-7.995 13.86 7.995-7.86 4.541-6-3.468-6.005 3.463v6.939l6 3.463 6-3.463 7.865 4.525-13.855 8.005z'/>"];

export { cibCodio };

